import { motion } from "framer-motion";
import { WHY } from "@/data/site";
import { Icon } from "@/lib/Icon";
import { Reveal, stagger, item } from "@/lib/motionPrimitives";

export default function WhyChooseUs() {
  return (
    <section id="why" className="relative bg-surface py-24 md:py-32" data-testid="why">
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <p className="overline">The Agraj Advantage</p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Why Choose Us
          </h2>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4"
        >
          {WHY.map((w) => (
            <motion.div
              key={w.title}
              variants={item}
              data-testid={`why-card-${w.title}`}
              className="group relative overflow-hidden rounded-3xl border border-border bg-background p-7"
            >
              <div
                className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-primary/10 opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-100"
                aria-hidden="true"
              />
              <div className="relative flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary transition-colors duration-300 group-hover:bg-primary group-hover:text-primary-foreground">
                <Icon name={w.icon} className="h-6 w-6" />
              </div>
              <h3 className="relative mt-5 font-display text-lg font-semibold">{w.title}</h3>
              <p className="relative mt-2 text-sm text-muted-foreground leading-relaxed">{w.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
